import React, { useState }  from "react";
// components
//import HomeNavbar from "../../components/Navbars/HomeNavbar";
import UserAttendanceRecords from "../../../components/Cards/UserAttendanceRecords.js";
import UserMonthlyAttendanceRecords from "../../../components/Cards/UserMonthlyAttendanceRecords.js";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import EmployeeAttendanceRecords from "../../../components/Cards/EmployeeAttendanceRecords.js";

 function AttendanceRecords(props) {
  
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  AttendanceRecords.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  export default function BasicTabs() {
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Daily Attendance" {...a11yProps(0)} />
            <Tab label="Monthly Attendance" {...a11yProps(1)} />
            <Tab label="Employee Attendance" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <AttendanceRecords value={value} index={0}>
          <UserAttendanceRecords />

        </AttendanceRecords>
        <AttendanceRecords value={value} index={1}>
        <UserMonthlyAttendanceRecords />
        </AttendanceRecords>
        <AttendanceRecords value={value} index={2}>
          <EmployeeAttendanceRecords />
        </AttendanceRecords>
      </Box>
    );
  }
